export function impressionFallbackCheck(data, parent) {
  if (
    // start of impression checks
    data.id == null
    || data.id === 'undefined'
    || data.component == null
    || data.component === 'undefined'
    || data.position == null
    || data.position === 'undefined'
    // start of container checks
    || parent.id == null
    || parent.id === 'undefined'
    || parent.component == null
    || parent.component === 'undefined'
    || parent.name == null
    || parent.name === 'undefined'
  ) {
    throw new Error(
      'ImpressionProvider or useImpression is missing a required value inside its data object'
    );
  }

  // TODO: Find a way to shorten this check above
  // start of impression checks
  // const required = (
  //     data.id &&
  //     data.component &&
  //     data.position &&
  //     parent.id &&
  //     parent.component &&
  //     parent.position
  //   )
  //   if (!required) {
  //     throw new Error('ImpressionProvider or useImpression is missing a required value inside its data object');
  //   }

  return { data, parent };
}
